// components/ContactForm.js
import React, { useState } from "react"; // useContext'i kaldırın
import { Mail, AlertTriangle, UploadCloud, MapPin, Phone, Clock } from 'lucide-react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    schoolInfo: "", 
    birthDate: "", 
    subject: "",
    message: "",
    contactMethod: "email",
    subscribe: false
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  
  // API URL'sini doğrudan tanımlayın
  const API_URL = "https://iyiliginmucitleri.com";

  const subjects = [
    "Genel Eğitim",
    "Çocuk",
    "Ortaokul",
    "Lise",
    "Aktif Gençlik",
    "Üniversite",
    "ATOM",
    "Genel Merkez",
    "Üniversite (Mesleki Gelişim)"
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = "Ad Soyad gereklidir";
    } else if (formData.name.length < 2) {
      newErrors.name = "Ad Soyad en az 2 karakter olmalıdır";
    }
    
    if (!formData.email.trim()) {
      newErrors.email = "E-posta gereklidir";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Geçerli bir e-posta adresi giriniz";
    }
    
    if (formData.phone && !/^[0-9+\-\s()]{10,}$/.test(formData.phone)) {
      newErrors.phone = "Geçerli bir telefon numarası giriniz";
    }
    
    if (!formData.schoolInfo.trim()) {
      newErrors.schoolInfo = "Okul bilgisi gereklidir";
    } else if (formData.schoolInfo.length < 3) {
      newErrors.schoolInfo = "Okul bilgisi en az 3 karakter olmalıdır";
    }
    
    if (!formData.birthDate) {
      newErrors.birthDate = "Doğum tarihi gereklidir";
    } else {
      const birthDate = new Date(formData.birthDate);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();
      
      // Yaş kontrolü (isteğe bağlı)
      if (age < 13) {
        newErrors.birthDate = "13 yaşından büyük olmalısınız";
      } else if (age > 100) {
        newErrors.birthDate = "Geçerli bir doğum tarihi giriniz";
      }
    }
    
    if (!formData.subject) {
      newErrors.subject = "Birim seçmelisiniz";
    }
    
    if (!formData.message.trim()) {
      newErrors.message = "Mesaj alanı boş bırakılamaz";
    } else if (formData.message.length < 10) {
      newErrors.message = "Mesaj en az 10 karakter olmalıdır";
    }
    
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const contactData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        schoolInfo: formData.schoolInfo,
        birthDate: formData.birthDate,
        subject: formData.subject,
        message: formData.message,
        contactMethod: formData.contactMethod,
        subscribe: formData.subscribe
      };
      
      console.log("Gönderilen veri:", contactData);
      console.log("API URL:", `${API_URL}/api/contact`);
      
      // API çağrısı - DOĞRU URL: https://iyiliginmucitleri.com/api/contact
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(contactData)
      });
      
      console.log("Response status:", response.status);
      
      // Response'u kontrol et
      if (!response.ok) {
        let errorMessage = `HTTP hatası! Durum: ${response.status}`;
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch (jsonError) {
          // JSON parse hatası, text olarak al
          const errorText = await response.text();
          errorMessage = errorText || errorMessage;
        }
        throw new Error(errorMessage);
      }
      
      const result = await response.json();
      console.log("API yanıtı:", result);
      
      if (result.success || response.status === 201) {
        // Başarılı gönderim
        setSubmitSuccess(true);
        setFormData({
          name: "",
          email: "",
          phone: "",
          schoolInfo: "",
          birthDate: "",
          subject: "",
          message: "",
          contactMethod: "email",
          subscribe: false
        });
        
        // Success mesajını 5 saniye sonra kaldır
        setTimeout(() => {
          setSubmitSuccess(false);
        }, 5000);
        
        // Hataları temizle
        setErrors({});
      } else {
        setErrors({ 
          submit: result.message || result.error || "Form gönderilirken bir hata oluştu." 
        });
      }
      
    } catch (error) {
      console.error("Form gönderme hatası:", error);
      setErrors({ 
        submit: `Form gönderilirken bir hata oluştu: ${error.message}` 
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      phone: "",
      schoolInfo: "",
      birthDate: "",
      subject: "",
      message: "",
      contactMethod: "email",
      subscribe: false
    });
    setErrors({});
    setSubmitSuccess(false);
  };

  return (
    <div style={{
      maxWidth: "800px",
      margin: "0 auto",
      padding: "32px 24px",
      fontFamily: "'Inter', sans-serif",
      minHeight: "calc(100vh - 64px)"
    }}>
      <div style={{
        marginBottom: "40px",
        textAlign: "center"
      }}>
        <h1 style={{
          fontSize: "32px",
          fontWeight: "700",
          color: "#2d3748",
          marginBottom: "12px",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text"
        }}>
          <Mail className="inline-icon"/> İletişim Formu
        </h1>
        <p style={{
          fontSize: "16px",
          color: "#718096",
          lineHeight: "1.6",
          maxWidth: "600px",
          margin: "0 auto"
        }}>
          Ekibimize dahil olmak için bizimle iletişime geçebilirsiniz.
          En kısa sürede size dönüş yapacağız.
        </p>
      </div>

      {submitSuccess && (
        <div style={{
          background: "linear-gradient(135deg, #48bb78 0%, #38a169 100%)",
          color: "white",
          padding: "16px 20px",
          borderRadius: "12px",
          marginBottom: "32px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          animation: "fadeIn 0.3s ease"
        }}>
          <span style={{ fontSize: "24px" }}><UploadCloud className="inline-icon"/></span>
          <div>
            <div style={{ fontWeight: "600", marginBottom: "4px" }}>
              Formunuz başarıyla gönderildi!
            </div>
            <div style={{ fontSize: "14px", opacity: 0.9 }}>
              En kısa sürede size dönüş yapacağız.
            </div>
          </div>
        </div>
      )}

      <div style={{
        background: "white",
        borderRadius: "16px",
        padding: "40px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.06)",
        border: "1px solid #e2e8f0",
        marginBottom: "40px"
      }}>
        <form onSubmit={handleSubmit}>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
            gap: "24px",
            marginBottom: "32px"
          }}>
            {/* Ad Soyad */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4a5568",
                marginBottom: "8px"
              }}>
                Ad Soyad *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1px solid ${errors.name ? "#fc8181" : "#e2e8f0"}`,
                  borderRadius: "10px",
                  fontSize: "15px",
                  transition: "all 0.2s ease",
                  backgroundColor: errors.name ? "#fff5f5" : "white"
                }}
                placeholder="Adınız ve soyadınız"
              />
              {errors.name && (
                <div style={{
                  color: "#e53e3e",
                  fontSize: "13px",
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                  <span><AlertTriangle className="inline-icon"/></span> {errors.name}
                </div>
              )}
            </div>

            {/* E-posta */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4a5568",
                marginBottom: "8px"
              }}>
                E-posta *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1px solid ${errors.email ? "#fc8181" : "#e2e8f0"}`,
                  borderRadius: "10px",
                  fontSize: "15px",
                  transition: "all 0.2s ease",
                  backgroundColor: errors.email ? "#fff5f5" : "white"
                }}
                placeholder="ornek@email.com"
              />
              {errors.email && (
                <div style={{
                  color: "#e53e3e",
                  fontSize: "13px",
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                  <span><AlertTriangle className="inline-icon"/></span> {errors.email}
                </div>
              )}
            </div>

            {/* Telefon */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4a5568",
                marginBottom: "8px"
              }}>
                Telefon Numarası
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1px solid ${errors.phone ? "#fc8181" : "#e2e8f0"}`,
                  borderRadius: "10px",
                  fontSize: "15px",
                  transition: "all 0.2s ease",
                  backgroundColor: errors.phone ? "#fff5f5" : "white"
                }}
                placeholder="+90 (XXX) XXX XX XX"
              />
              {errors.phone && (
                <div style={{
                  color: "#e53e3e",
                  fontSize: "13px",
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                  <span><AlertTriangle className="inline-icon"/></span> {errors.phone}
                </div>
              )}
            </div>

            {/* Okul Bilgisi */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4a5568",
                marginBottom: "8px"
              }}>
                Okul Bilgisi *
              </label>
              <input
                type="text"
                name="schoolInfo"
                value={formData.schoolInfo}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1px solid ${errors.schoolInfo ? "#fc8181" : "#e2e8f0"}`,
                  borderRadius: "10px",
                  fontSize: "15px",
                  transition: "all 0.2s ease",
                  backgroundColor: errors.schoolInfo ? "#fff5f5" : "white"
                }}
                placeholder="Okul adı, bölüm, sınıf (örn: İstanbul Üniversitesi, Bilgisayar Mühendisliği 3. sınıf)"
              />
              {errors.schoolInfo && (
                <div style={{
                  color: "#e53e3e",
                  fontSize: "13px",
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                  <span><AlertTriangle className="inline-icon"/></span> {errors.schoolInfo}
                </div>
              )}
            </div>

            {/* Doğum Tarihi */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4a5568",
                marginBottom: "8px"
              }}>
                Doğum Tarihi *
              </label>
              <input
                type="date"
                name="birthDate"
                value={formData.birthDate}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1px solid ${errors.birthDate ? "#fc8181" : "#e2e8f0"}`,
                  borderRadius: "10px",
                  fontSize: "15px",
                  transition: "all 0.2s ease",
                  backgroundColor: errors.birthDate ? "#fff5f5" : "white",
                  cursor: "pointer"
                }}
                max={new Date().toISOString().split('T')[0]}
              />
              {errors.birthDate && (
                <div style={{
                  color: "#e53e3e",
                  fontSize: "13px",
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                  <span><AlertTriangle className="inline-icon"/></span> {errors.birthDate}
                </div>
              )}
            </div>

            {/* Birimler */}
            <div>
              <label style={{
                display: "block",
                fontSize: "14px",
                fontWeight: "600",
                color: "#4a5568",
                marginBottom: "8px"
              }}>
                Birimler *
              </label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1px solid ${errors.subject ? "#fc8181" : "#e2e8f0"}`,
                  borderRadius: "10px",
                  fontSize: "15px",
                  transition: "all 0.2s ease",
                  backgroundColor: errors.subject ? "#fff5f5" : "white",
                  cursor: "pointer"
                }}
              >
                <option value="">Birim seçiniz</option>
                {subjects.map((subject) => (
                  <option key={subject} value={subject}>
                    {subject}
                  </option>
                ))}
              </select>
              {errors.subject && (
                <div style={{
                  color: "#e53e3e",
                  fontSize: "13px",
                  marginTop: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}>
                  <span><AlertTriangle className="inline-icon"/></span> {errors.subject}
                </div>
              )}
            </div>
          </div>

          {/* İletişim Tercihi */}
          <div style={{ marginBottom: "32px" }}>
            <div style={{
              fontSize: "14px",
              fontWeight: "600",
              color: "#4a5568",
              marginBottom: "12px"
            }}>
              Tercih Ettiğiniz İletişim Yöntemi
            </div>
            <div style={{
              display: "flex",
              gap: "24px",
              flexWrap: "wrap"
            }}>
                {[
                { value: "email", label: "E-posta", icon: <Mail /> },
                { value: "phone", label: "Telefon", icon: <Phone /> },
                { value: "both", label: "Her İkisi", icon: <AlertTriangle /> }
              ].map((method) => (
                <label
                  key={method.value}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "12px 20px",
                    border: `2px solid ${formData.contactMethod === method.value ? "#667eea" : "#e2e8f0"}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    backgroundColor: formData.contactMethod === method.value 
                      ? "rgba(102, 126, 234, 0.08)" 
                      : "white",
                    flex: 1,
                    minWidth: "140px"
                  }}
                >
                  <input
                    type="radio"
                    name="contactMethod"
                    value={method.value}
                    checked={formData.contactMethod === method.value}
                    onChange={handleChange}
                    style={{
                      display: "none"
                    }}
                  />
                  <span style={{ fontSize: "20px" }}>{method.icon}</span>
                  <div>
                    <div style={{ fontWeight: "600", color: "#2d3748" }}>
                      {method.label}
                    </div>
                  </div>
                </label>
              ))}
            </div>
          </div>

          {/* Mesaj */}
          <div style={{ marginBottom: "32px" }}>
            <label style={{
              display: "block",
              fontSize: "14px",
              fontWeight: "600",
              color: "#4a5568",
              marginBottom: "8px"
            }}>
              Mesajınız *
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="6"
              style={{
                width: "100%",
                padding: "16px",
                border: `1px solid ${errors.message ? "#fc8181" : "#e2e8f0"}`,
                borderRadius: "10px",
                fontSize: "15px",
                transition: "all 0.2s ease",
                backgroundColor: errors.message ? "#fff5f5" : "white",
                resize: "vertical",
                lineHeight: "1.5"
              }}
              placeholder="Ekibimize katılmak istemenizin sebebi, tecrübeleriniz veya önerileriniz hakkında bilgi verin..."
            />
            {errors.message && (
              <div style={{
                color: "#e53e3e",
                fontSize: "13px",
                marginTop: "6px",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}>
                <span><AlertTriangle className="inline-icon"/></span> {errors.message}
              </div>
            )}
          </div>

         

          {/* Submit Error */}
          {errors.submit && (
            <div style={{
              backgroundColor: "#fff5f5",
              color: "#e53e3e",
              padding: "16px",
              borderRadius: "10px",
              marginBottom: "24px",
              border: "1px solid #fed7d7",
              display: "flex",
              alignItems: "center",
              gap: "10px"
            }}>
              <span style={{ fontSize: "20px" }}><AlertTriangle className="inline-icon"/></span>
              <div style={{ fontWeight: "500" }}>{errors.submit}</div>
            </div>
          )}

          {/* Butonlar */}
          <div style={{
            display: "flex",
            gap: "16px",
            justifyContent: "flex-end"
          }}>
            <button
              type="button"
              onClick={handleReset}
              style={{
                padding: "14px 28px",
                border: "1px solid #e2e8f0",
                backgroundColor: "white",
                color: "#4a5568",
                borderRadius: "10px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: "pointer",
                transition: "all 0.2s ease",
                minWidth: "120px"
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#f7fafc";
                e.target.style.borderColor = "#cbd5e0";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "white";
                e.target.style.borderColor = "#e2e8f0";
              }}
            >
              Temizle
            </button>
            
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                padding: "14px 28px",
                border: "none",
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                color: "white",
                borderRadius: "10px",
                fontSize: "15px",
                fontWeight: "600",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                opacity: isSubmitting ? 0.7 : 1,
                minWidth: "140px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px"
              }}
              onMouseEnter={(e) => {
                if (!isSubmitting) {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 8px 20px rgba(102, 126, 234, 0.3)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSubmitting) {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }
              }}
            >
              {isSubmitting ? (
                <>
                  <div style={{
                    width: "16px",
                    height: "16px",
                    border: "2px solid rgba(255,255,255,0.3)",
                    borderTopColor: "white",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                  }} />
                  Gönderiliyor...
                </>
              ) : (
                <>
                  <span><UploadCloud className="inline-icon"/></span>
                  Gönder
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      {/* İletişim Bilgileri */}
      <div style={{
        padding: "32px",
        background: "linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)",
        borderRadius: "16px",
        border: "1px solid rgba(102, 126, 234, 0.1)"
      }}>
          <h2 style={{
          fontSize: "20px",
          fontWeight: "600",
          color: "#2d3748",
          marginBottom: "24px",
          textAlign: "center"
        }}>
          <MapPin className="inline-icon"/> Diğer İletişim Bilgileri
        </h2>
        
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "24px",
          textAlign: "center"
        }}>
            <div>
            <div style={{ fontSize: "32px", marginBottom: "12px" }}><Phone className="inline-icon"/></div>
            <div style={{ fontWeight: "600", color: "#2d3748", marginBottom: "4px" }}>
              Telefon
            </div>
            <div style={{ color: "#718096", fontSize: "15px" }}>
              0 (212) 123 45 67
            </div>
          </div>
          
          <div>
            <div style={{ fontSize: "32px", marginBottom: "12px" }}><Mail className="inline-icon"/></div>
            <div style={{ fontWeight: "600", color: "#2d3748", marginBottom: "4px" }}>
              E-posta
            </div>
            <div style={{ color: "#718096", fontSize: "15px" }}>
              info@ihhegitim.com
            </div>
          </div>
          
          <div>
            <div style={{ fontSize: "32px", marginBottom: "12px" }}><MapPin className="inline-icon"/></div>
            <div style={{ fontWeight: "600", color: "#2d3748", marginBottom: "4px" }}>
              Adres
            </div>
            <div style={{ color: "#718096", fontSize: "15px" }}>
              İHH Merkez Ofis, İstanbul
            </div>
          </div>
          
          <div>
            <div style={{ fontSize: "32px", marginBottom: "12px" }}><Clock className="inline-icon"/></div>
            <div style={{ fontWeight: "600", color: "#2d3748", marginBottom: "4px" }}>
              Çalışma Saatleri
            </div>
            <div style={{ color: "#718096", fontSize: "15px" }}>
              Pazartesi-Cuma: 09:00-18:00
            </div>
          </div>
        </div>
      </div>

      {/* CSS Animasyonları */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          
          input:focus, textarea:focus, select:focus {
            outline: none;
            border-color: #667eea !important;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          }
          
          /* Date input için özel stiller */
          input[type="date"]::-webkit-calendar-picker-indicator {
            cursor: pointer;
            opacity: 0.6;
            transition: opacity 0.2s ease;
          }
          
          input[type="date"]::-webkit-calendar-picker-indicator:hover {
            opacity: 1;
          }
        `}
      </style>
      
    </div>
  );
};

export default ContactForm;
